module.exports = __webpack_public_path__ + "img/finish.606aab4f.png";